export default {
  description:
    'Upload the documents we need to verify your business. Required documents are marked; you can add the optional ones now or later.',
  missing_one: 'A required document is still missing. You can carry on: this step stays open until it is uploaded.',
  missing_other:
    '{{count}} required documents are still missing. You can carry on: this step stays open until they are uploaded.',
  buttons: {
    back: 'Back',
    next: 'Next',
    finish_later: 'Finish later',
  },
};
